import MainCatalogsEditorBase from '../MainCatalogsEditorBase';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './VenueEditor.html?raw';
import Edit from '../../../moreCore/UI/Edit/Edit';
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import HintBox from '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import { MainCatalogTypes, MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";

class VenueEditor extends compose(MainCatalogsEditorBase) {
    templateString: any = template;


    ve_Input_Code: MdsLax<InstanceType<typeof Edit>>;
    ve_Input_Description: MdsLax<InstanceType<typeof Edit>>;
    ve_Input_TextColor: HTMLInputElement;
    ve_Input_BackgroundColor: HTMLInputElement;
    ve_Input_Order: MdsLax<InstanceType<typeof NumberInput>>;
    ve_Checkbox_HomeVenue: MdsLax<InstanceType<typeof CheckBox>>;

    ve_Hintbox_Address: MdsLax<InstanceType<typeof HintBox>>;
    ve_Hintbox_AddressRunner: MdsLax<InstanceType<typeof HintBox>>;

    readonlyAddressDataContainer: HTMLElement;
    readonlyAddressRunnerDataContainer: HTMLElement;

    readonlyAddressNote: HTMLTextAreaElement;
    readonlyAddressBuilding: HTMLInputElement;
    readonlyAddressStreet: HTMLInputElement;
    readonlyAddressPostalCode: HTMLInputElement;
    readonlyAddressCity: HTMLInputElement;
    readonlyAddressCountry: HTMLInputElement;

    readonlyAddressRunnerNote: HTMLTextAreaElement;
    readonlyAddressRunnerBuilding: HTMLInputElement;
    readonlyAddressRunnerStreet: HTMLInputElement;
    readonlyAddressRunnerPostalCode: HTMLInputElement;
    readonlyAddressRunnerCity: HTMLInputElement;
    readonlyAddressRunnerCountry: HTMLInputElement;


    formData: MainCatalogTypes.Venue_SaveData = {
        ID: "",
        is_new_status: null,
        code: "",
        description: "",
        order: null,
        coloration: null,
        is_home_venue: null,
        address_id: "",
        address_runner_id: ""
    };

    prepareFormData(data?: MainCatalogTypes.Venue_LoadData): void {

        if (data) {

            this.ve_Input_Code.setValue(data.code, true);
            this.ve_Input_Description.setValue(data.description, true);

            this.ve_Input_TextColor.value = data.coloration.TextColor.Hex;
            this.ve_Input_BackgroundColor.value = data.coloration.BackColor.Hex;

            this.ve_Input_Order.setValue(data.order, true);

            this.ve_Checkbox_HomeVenue.setValue(data.is_home_venue, true);

            this.ve_Hintbox_Address.setValue(data.ref_address, true);
            this.prepareHintboxReadonlyData("Address", data.ref_address);

            this.ve_Hintbox_AddressRunner.setValue(data.ref_address_runner, true);
            this.prepareHintboxReadonlyData("AddressRunner", data.ref_address_runner);

            this.formData.ID = data.ID;
            this.formData.is_new_status = false;
        } else {

            this.ve_Input_Code.setValue("", true);
            this.ve_Input_Description.setValue("", true);

            this.ve_Input_BackgroundColor.value = "#ffffff";
            this.ve_Input_TextColor.value = "#000000";

            this.ve_Input_Order.setValue(null, true);

            this.ve_Checkbox_HomeVenue.setValue(false, true);

            this.ve_Hintbox_Address.setValue(null, true);
            this.prepareHintboxReadonlyData("Address", null);

            this.ve_Hintbox_AddressRunner.setValue(null, true);
            this.prepareHintboxReadonlyData("AddressRunner", null);

            this.formData.ID = "";
            this.formData.is_new_status = true;
        }

        this.serializeFormData();
        this.originalData = JSON.stringify(this.formData);
        console.debug("ORIGINAL", this.originalData);

        this.StandbyStop();
        this.checkDirty();
    }

    serializeFormData(): void {

        this.formData.code = this.ve_Input_Code.getValue();
        this.formData.description = this.ve_Input_Description.getValue();

        this.formData.order = this.ve_Input_Order.getValue();

        this.formData.is_home_venue = this.ve_Checkbox_HomeVenue.getValue();

        this.formData.address_id = this.ve_Hintbox_Address.getValue("value");
        this.formData.address_runner_id = this.ve_Hintbox_AddressRunner.getValue("value");

        let coloration: MainCatalogTypes.PIT_Coloration = {
            TextColor: null,
            BackColor: null
        };
        let textColor: MainCatalogTypes.PIT_Color = {
            Hex: "",
            Red: 0,
            Green: 0,
            Blue: 0
        };
        let backColor: MainCatalogTypes.PIT_Color = {
            Hex: "",
            Red: 0,
            Green: 0,
            Blue: 0
        };
        let textHex = this.ve_Input_TextColor.value;
        let backHex = this.ve_Input_BackgroundColor.value;

        textColor.Hex = textHex;
        textColor.Red = parseInt(textHex.slice(1, 3), 16);
        textColor.Green = parseInt(textHex.slice(3, 5), 16);
        textColor.Blue = parseInt(textHex.slice(5, 7), 16);

        backColor.Hex = backHex;
        backColor.Red = parseInt(backHex.slice(1, 3), 16);
        backColor.Green = parseInt(backHex.slice(3, 5), 16);
        backColor.Blue = parseInt(backHex.slice(5, 7), 16);

        coloration.TextColor = textColor;
        coloration.BackColor = backColor;

        this.formData.coloration = coloration;

        console.debug("SERIALIZED DATA", this.formData);
    }


    isValid(): boolean {

        let b: boolean = true;

        if (!this.formData.code) b = false;

        if (!this.formData.description) b = false;

        return b;
    }


    _onChangeHintboxAddressInputData(): void {

        let entity: MainCatalogTypes.Venue_HintboxAddressData = this.ve_Hintbox_Address.getValue("entity");

        this.prepareHintboxReadonlyData("Address", entity);

        this.serializeFormData();
        this.checkDirty();
    }

    _onChangeHintboxAddressRunnerInputData(): void {

        let entity: MainCatalogTypes.Venue_HintboxAddressData = this.ve_Hintbox_AddressRunner.getValue("entity");

        this.prepareHintboxReadonlyData("AddressRunner", entity);

        this.serializeFormData();
        this.checkDirty();
    }

    prepareHintboxReadonlyData(hintbox: "Address" | "AddressRunner", entity: MainCatalogTypes.Venue_HintboxAddressData): void {

        switch (hintbox) {
            case "Address":
                if (entity) {

                    this.UiModder.domClass.remove(this.readonlyAddressDataContainer, "w3-hide");

                    this.showHideAddressHintboxDataReadonly(entity.note, this.readonlyAddressNote);
                    this.showHideAddressHintboxDataReadonly(entity.building, this.readonlyAddressBuilding);
                    this.showHideAddressHintboxDataReadonly(entity.street, this.readonlyAddressStreet);
                    this.showHideAddressHintboxDataReadonly(entity.c_postal_code, this.readonlyAddressPostalCode);
                    this.showHideAddressHintboxDataReadonly(entity.c_city, this.readonlyAddressCity);
                    this.showHideAddressHintboxDataReadonly(entity.ref_country?.description, this.readonlyAddressCountry);
                } else {

                    this.UiModder.domClass.add(this.readonlyAddressDataContainer, "w3-hide");

                    this.showHideAddressHintboxDataReadonly("", this.readonlyAddressNote);
                    this.showHideAddressHintboxDataReadonly("", this.readonlyAddressBuilding);
                    this.showHideAddressHintboxDataReadonly("", this.readonlyAddressStreet);
                    this.showHideAddressHintboxDataReadonly("", this.readonlyAddressPostalCode);
                    this.showHideAddressHintboxDataReadonly("", this.readonlyAddressCity);
                    this.showHideAddressHintboxDataReadonly("", this.readonlyAddressCountry);
                }
                break;

            case "AddressRunner":
                if (entity) {

                    this.UiModder.domClass.remove(this.readonlyAddressRunnerDataContainer, "w3-hide");

                    this.showHideAddressHintboxDataReadonly(entity.note, this.readonlyAddressRunnerNote);
                    this.showHideAddressHintboxDataReadonly(entity.building, this.readonlyAddressRunnerBuilding);
                    this.showHideAddressHintboxDataReadonly(entity.street, this.readonlyAddressRunnerStreet);
                    this.showHideAddressHintboxDataReadonly(entity.c_postal_code, this.readonlyAddressRunnerPostalCode);
                    this.showHideAddressHintboxDataReadonly(entity.c_city, this.readonlyAddressRunnerCity);
                    this.showHideAddressHintboxDataReadonly(entity.ref_country?.description, this.readonlyAddressRunnerCountry);
                } else {

                    this.UiModder.domClass.add(this.readonlyAddressRunnerDataContainer, "w3-hide");

                    this.showHideAddressHintboxDataReadonly("", this.readonlyAddressRunnerNote);
                    this.showHideAddressHintboxDataReadonly("", this.readonlyAddressRunnerBuilding);
                    this.showHideAddressHintboxDataReadonly("", this.readonlyAddressRunnerStreet);
                    this.showHideAddressHintboxDataReadonly("", this.readonlyAddressRunnerPostalCode);
                    this.showHideAddressHintboxDataReadonly("", this.readonlyAddressRunnerCity);
                    this.showHideAddressHintboxDataReadonly("", this.readonlyAddressRunnerCountry);
                }
                break;
        }
    }

    showHideAddressHintboxDataReadonly(value: string, node: HTMLTextAreaElement | HTMLInputElement,): void {

        if (value) {

            this.UiModder.domClass.remove(node, "w3-hide");
            this.UiModder.domClass.remove(node.parentElement, "w3-hide");
            node.value = value;
        } else {

            this.UiModder.domClass.add(node, "w3-hide");
            this.UiModder.domClass.add(node.parentElement, "w3-hide");
            node.value = "";
        }
    }


    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.entityClass = MainCatalogs_Classes.Venues;

        this.ve_Input_Code.setMaxLength(10);
        this.ve_Input_Description.setMaxLength(255);

        this.ve_Hintbox_Address.enablePlainTextValue = false;
        this.ve_Hintbox_Address._setPlaceholderAttr(this.translations["MainCatalogsEditor_Placeholder_HintboxSearchAddress"]);

        this.ve_Hintbox_AddressRunner.enablePlainTextValue =false;
        this.ve_Hintbox_AddressRunner._setPlaceholderAttr(this.translations["MainCatalogsEditor_Placeholder_HintboxSearchAddress"]);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

mdsLazyProto(VenueEditor.prototype, {
  ve_Input_Code: () => (new Edit()),
  ve_Input_Description: () => (new Edit()),
  ve_Input_Order: () => (new NumberInput()),
  ve_Checkbox_HomeVenue: () => (new CheckBox()),
  ve_Hintbox_Address: () => (new HintBox()),
  ve_Hintbox_AddressRunner: () => (new HintBox()),
});
export default mdsWidget(VenueEditor);
